import React from 'react'
import { Field } from 'formular'
import { Modal, ModalVisibilityProps } from 'sb-modal'

import { Box } from 'components/_new/layout'
import { FormularField } from 'components/_new/forms'

import messages from './messages'


type SubscriptionWasCancelledModalViewProps = Pick<ModalVisibilityProps, 'onClose'> & {
  commentsField: Field<string>
  onSubmit: () => void
}

const SubscriptionWasCancelledModalView: React.FunctionComponent<SubscriptionWasCancelledModalViewProps> = (props) => {
  const {
    commentsField, onSubmit, onClose,
  } = props

  return (
    <Modal
      className="humbleBgColor"
      iconName="sadBird"
      iconColor="brand-30"
      title={messages.title}
      text={messages.text}
      primaryButton={{
        title: messages.submitButton,
        rightIcon: 'rightArrowSmall',
        onClick: onSubmit,
      }}
      onClose={onClose}
      dataTestId="subscriptionWasCancelledModal"
    >
      <Box mt={32}>
        <FormularField
          field={commentsField}
          rows={5}
          autosize
          placeholder={messages.comments}
          standardView
          dataTestId="unsubscribeComments"
        />
      </Box>
    </Modal>
  )
}


export default SubscriptionWasCancelledModalView
